import { Badge, BadgeProps, Box } from "@mantine/core"

import { useGetOperations } from "~/utils/operations"

type Props = BadgeProps & {
  activityName: string
}
export const ActivityBadge = ({ activityName, ...props }: Props) => {
  const activityInfo = useGetOperations()[activityName]
  return (
    <Badge
      color="gray"
      {...props}
      leftSection={
        <Box mt={4}>{activityInfo.icon && <activityInfo.icon size={12} />}</Box>
      }
    >
      {activityInfo.name}
    </Badge>
  )
}
